<script lang="ts" setup>
import type {MenuPrototypeIconId} from '~/utils/personalMenuPrototypeIcons'

defineProps<{
  name: MenuPrototypeIconId
}>()
</script>

<template>
  <!-- SVG markup copied from Обновление ЛК клиники.html (clinic LK sidebar, lines 2290–2298) -->
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
    <template v-if="name === 'profile'">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20c1.5-3.5 4.5-5 8-5s6.5 1.5 8 5" />
    </template>
    <template v-else-if="name === 'requisites'">
      <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" />
      <path d="M14 2v6h6M8 13h8M8 17h5" />
    </template>
    <template v-else-if="name === 'notifications'">
      <path d="M18 8A6 6 0 106 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 01-3.46 0" />
    </template>
    <template v-else-if="name === 'integrations'">
      <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
      <circle cx="12" cy="12" r="3" />
    </template>
    <template v-else-if="name === 'applications'">
      <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2" />
      <rect x="9" y="3" width="6" height="4" rx="1" />
      <path d="M9 12h6M9 16h4" />
    </template>
    <template v-else-if="name === 'online-consultations'">
      <path d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
    </template>
    <template v-else-if="name === 'reviews'">
      <path d="M12 17.3l-6.18 3.7 1.64-7.03L2 9.24l7.19-.61L12 2l2.81 6.63 7.19.61-5.46 4.73 1.64 7.03z" />
    </template>
    <template v-else-if="name === 'showcase'">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" />
      <path d="M3 6h18M16 10a4 4 0 01-8 0" />
    </template>
    <template v-else-if="name === 'orders'">
      <path d="M21 8l-9-5-9 5v8l9 5 9-5V8z" />
      <path d="M3 8l9 5 9-5M12 13v8" />
    </template>
    <template v-else-if="name === 'referral-program'">
      <path d="M7 12h7M11 8l4 4-4 4" />
      <path d="M5 5h6v4M5 19h6v-4" />
    </template>
  </svg>
</template>
